import { Badge, BadgeVariation } from '@stories/Theme/Badge/Badge'

const CampPageBadge = (props: {
  data: { color: string; name: string }
  campId?: string
  index?: string
  fontSize?: string
}) => {
  const data = props.data

  const dataTestId = props.campId && props.index && `interest-tag-${props.campId}-scrolling-value-${props.index}`

  return (
    <Badge variant={data.color as BadgeVariation} dataTestId={`${dataTestId}`} fontSize={props.fontSize}>
      {data.name}
    </Badge>
  )
}

export default CampPageBadge
